<div class="image-block">

  @if (IsLoading) {
    <div>
      <app-preloader></app-preloader>
    </div>
  }
  @if (!ImageUrl && !IsLoading) {
    <div class="no-image-block">
      <p> Нет изображения!</p>
      @if (IsSelected) {
        <div class="file-wrapper" (click)="$event.stopPropagation()">
          <br>
            <input
              [id]="'image'+ItemUid"
              type="file"
              accept="image/png, image/jpeg"
              (change)="ChangeItemFile($event.target);"
              >
            <label [for]="'image'+ItemUid"><img src="assets/icons/download.svg">Загрузить изображение</label>
          </div>
        }
      </div>
    }




    <div>


      <div class="image-wrapper" [ngClass]="{'edited': IsSelected}">

        <img class="image"
          [hidden]="!ImageUrl || IsLoading"
          [src]="ImageUrl"
          (load)="onLoad()"
          (error)="IsLoading = false"
          alt="Изображение"
          [style.max-width]="(Scale && !IsSelected) ? (100 * Scale) + '%' : '100%'"
          [style.margin]="'0 auto'"
          >

        @if (ImageUrl && !IsLoading && IsSelected) {
          <div class="replace" (click)="$event.stopPropagation()">
            <input
              [id]="'image'+ItemUid"
              type="file"
              style="display: none;"
              accept="image/png, image/jpeg"
              (change)="ChangeItemFile($event.target)"
              >
            <label [for]="'image'+ItemUid">
              <div class="replace-control">
                Загрузить изображение
              </div>
            </label>
          </div>
        }
      </div>

      @if(IsSelected && ImageUrl) {

        <div class="buttons">
          <div class="button" [class.active]="Scale === null || Scale === 1.0" (click)="ChangeSize(1.0); $event.stopPropagation()">100%</div>
          <div class="button" [class.active]="Scale === 0.75" (click)="ChangeSize(0.75); $event.stopPropagation()">75%</div>
          <div class="button" [class.active]="Scale === 0.5" (click)="ChangeSize(0.5); $event.stopPropagation()">50%</div>
        </div>
      }
    </div>

    <!-- (click)="downloadImage();$event.stopPropagation()" -->
  </div>
